import React, {useEffect, useState} from 'react';
import {Modal, ProgressBar} from 'react-bootstrap';
import {adminHttp} from "~/Admin/services/http";
import {connect} from "react-redux";
import Upload from "~/Components/Upload/Upload";
import {humanFileSize} from "~/helpers/utils";
import deleteIcon from "~/assets/icons/delete.png";
import Moment from "react-moment";
import {DownloadIcon} from "~/Components/Icons/Icons";
import ConfirmedButton from "~/Components/ConfirmedButton/ConfirmedButton";

const AdminImageUploader = ({event, image, children, onChanged, ...rest}) => {

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);
    const [fileToUpload, setFileToUpload] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);

    const [imageModel, setImageModel] = useState(image);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const addFile = (files) => {
        setFileToUpload(files[0]);
    }

    const removeFile = () => {
        setError('');
        setFileToUpload(null);
    }

    const cancel = () => {
        setUploading(false);
        setFileToUpload(null);
        setError('');
    }

    const handleDelete = () => {
        adminHttp
            .delete("/images/" + image.id)
            .then((response) => {
                setImageModel(response.data);
                onChanged(response.data);
            });
    };

    const startUpload = () => {

        setUploading(true);

        let formData = new FormData();
        formData.append("file", fileToUpload);

        const onUploadProgress = (event) => {
            let newProgress = Math.round((100 * event.loaded) / event.total);
            setProgress(Math.max(newProgress, progress));
        }

        adminHttp.post("/images/" + image.id + "/upload", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            onUploadProgress,
        }).then((response) => {

            setImageModel(response.data);

            if (onChanged) {
                onChanged(response.data);
            }

            cancel();

        }).catch((error) => {
            setProgress(0);
            setUploading(false);
            setError(error.response?.data);
        });
    }

    return (
        <>
            <a {...rest} onClick={handleShow}>{children}</a>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Upload Image</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="row">

                        <div className="col-12">
                            <Upload maxFiles={1} accept="png,jpg,svg" acceptMimes="image/*"
                                    sendFiles={(files) => addFile(files)}/>
                        </div>

                        {fileToUpload && (
                            <>
                                <div className="col-12">
                                    {!error && uploading && <ProgressBar now={progress}/>}

                                    {error && (
                                        <div className="alert alert-danger" role="alert">
                                            {error.message || 'Failed to upload file!'}
                                        </div>
                                    )}

                                    <AdminImageUploadingFile
                                        onRemove={() => removeFile()}
                                        errors={error?.errors || []}
                                        file={fileToUpload}/>

                                </div>
                                <div className="col-12">
                                    <button className="btn btn-primary mr-3 btn-sm"
                                            onClick={() => startUpload()}>Upload
                                    </button>

                                    <a className="btn btn-secondary btn-sm" onClick={(e) => cancel()}>Cancel</a>
                                </div>
                            </>
                        )}

                        {!fileToUpload && imageModel && imageModel.diskname && (
                            <div className="col-12 mt-3">
                                <p className="font-weight-500">UPLOADED FILE</p>
                                <table className="table table-sm">
                                    <tbody>
                                    <tr>
                                        <td>Name:</td>
                                        <td>{imageModel.name}</td>
                                    </tr>
                                    <tr>
                                        <td>Size:</td>
                                        <td>{humanFileSize(imageModel.size)}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-nowrap">Uploaded At:</td>
                                        <td><Moment format="DD/MM/YYYY h:mm:ss a" date={imageModel.updated_at}/></td>
                                    </tr>
                                    <tr>
                                        <td>Download:</td>
                                        <td>
                                            <a className="d-inline cursor-pointer" href={imageModel.download_url}>
                                                <DownloadIcon classes="d-inline"/>
                                            </a>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        )}

                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button onClick={handleClose} className="btn btn-secondary btn-sm d-inline">Close</button>
                    {imageModel && imageModel.diskname && (
                        <ConfirmedButton className="btn btn-danger btn-sm d-inline" onClick={handleDelete}>
                            Delete
                        </ConfirmedButton>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    );
}

const AdminImageUploadingFile = ({file, errors = [], onRemove, ...props}) => {

    return (
        <>
            <div className="row">
                <div className="col-10">{file.name} ({humanFileSize(file.size)})</div>
                <div className="col-2">
                    <a className="btn" onClick={() => onRemove()}><img src={deleteIcon}/></a>
                </div>
            </div>
            {errors.length > 0 && (
                <div className="row">
                    <div className="col-12">
                        <small className="text-danger">{errors}</small>
                    </div>
                </div>
            )}
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminImageUploader);
